const leaflets = {
  "iperbimbo": {
    "config": {
      "primary-color": "#5ac5f3",
      "secondary-color": "#e30713",
      "tertiary-color": "#ffdd00",
      "hover-color": "rgba(220, 35, 17, 0.5)",
      "clientIcon": require("assets/images/clientLogo_iperbimbo.png"),
      "serverPath": "demo1.catalogointerattivo.net/",
      "pdfPath": "/media/pdf/catalogo.pdf",
      "shareFlyerTitle": "Dai uno sguardo al Catalogo di Interattivo di Iperbimbo!",
      "shareFlyerURL": "https://demo1.catalogointerattivo.net?v=172",
      "shareProductSentence": "Guarda questa fantastica offerta!",
      "ogTitleMeta": "Iperbimbo | Catalogo Interattivo",
      "ogDescriptionMeta": "Dai uno sguardo al nuovo catalogo di Iperbimbo.",
      "ogImageMeta": "https://demo1.catalogointerattivo.net/media/images/catalogo_fb.png",
      "filterBrand": 0,
      "filterUnderprice": 0,
      "brandImage": "",
      "underPriceImage": "",
      "ga_active": false,
      "ga_tracking_id": "UA-152069090-10",
      "release_id": "2",
      "send_grocery_list_to_market": false,
      "grocery_list_min_value": 10,
      "client_id": 7,
      "signboard_id": 11,
      "has_pages": true,
      "hide_grocery_list": true,
      "hide_searchbar": false,
      "line_through": false,
      "category_banner": "",
      "category_banner_mobile": "",
      "hide_plus_product": false,
      "hide_plus_product_price": false,
      "type": "leaflet",
      "product_banner": "cstm69543145",
      "href_banner": "",
      "internal_banner_click": false,
      "external_banner_click": false,
      "hide_listPages": false,
      "type": "catalog"
    },
    "leaflet": {
      "name": "Iperbimbo Catalogo giochi",
      "code": "172",
      "id_campaign": "172",
      "index": {
        "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/Indice-Iperbimbocatalogo-giochi_NhTmMLU.png",
        "links": [
          {
            "page": 2,
            "blueprint": {
              "top": 20.15220109196701,
              "left": 12.875891836403145,
              "width": 74.81793461573352,
              "height": 4.308704526934945
            }
          },
          {
            "page": 22,
            "blueprint": {
              "top": 24.539309074937133,
              "left": 12.584573421303796,
              "width": 74.81793461573352,
              "height": 4.308704526934945
            }
          },
          {
            "page": 30,
            "blueprint": {
              "top": 28.958776398641906,
              "left": 12.449413368507967,
              "width": 74.81793461573352,
              "height": 4.308704526934945
            }
          },
          {
            "page": 38,
            "blueprint": {
              "top": 33.20691696796071,
              "left": 12.645417783689055,
              "width": 74.81793461573352,
              "height": 4.308704526934945
            }
          },
          {
            "page": 41,
            "blueprint": {
              "top": 37.81141986338286,
              "left": 12.57272259029783,
              "width": 74.81793461573352,
              "height": 4.308704526934945
            }
          },
          {
            "page": 48,
            "blueprint": {
              "top": 42.07022284618165,
              "left": 12.526417266590817,
              "width": 74.81793461573352,
              "height": 4.308704526934945
            }
          },
          {
            "page": 60,
            "blueprint": {
              "top": 46.56964354759339,
              "left": 12.233485926888099,
              "width": 74.81793461573352,
              "height": 4.308704526934945
            }
          },
          {
            "page": 70,
            "blueprint": {
              "top": 50.990639427184945,
              "left": 12.469343967362727,
              "width": 74.81793461573352,
              "height": 4.308704526934945
            }
          },
          {
            "page": 78,
            "blueprint": {
              "top": 55.396023156283086,
              "left": 12.416571800410287,
              "width": 74.81793461573352,
              "height": 4.308704526934945
            }
          },
          {
            "page": 84,
            "blueprint": {
              "top": 59.82577276223155,
              "left": 12.277648256873267,
              "width": 74.81793461573352,
              "height": 4.308704526934945
            }
          },
          {
            "page": 89,
            "blueprint": {
              "top": 64.23191675380227,
              "left": 12.754740753167084,
              "width": 74.81793461573352,
              "height": 4.308704526934945
            }
          },
          {
            "page": 97,
            "blueprint": {
              "top": 68.43779583137903,
              "left": 12.645970570055468,
              "width": 74.81793461573352,
              "height": 4.308704526934945
            }
          },
          {
            "page": 101,
            "blueprint": {
              "top": 72.66309372577321,
              "left": 12.48657878612923,
              "width": 74.81793461573352,
              "height": 4.308704526934945
            }
          },
          {
            "page": 105,
            "blueprint": {
              "top": 77.06314490964108,
              "left": 12.761745237946968,
              "width": 74.81793461573352,
              "height": 4.308704526934945
            }
          },
          {
            "page": 109,
            "blueprint": {
              "top": 81.36001990964108,
              "left": 12.71381941722061,
              "width": 74.81793461573352,
              "height": 4.308704526934945
            }
          },
          {
            "page": 112,
            "blueprint": {
              "top": 85.63100850784558,
              "left": 12.678812138153148,
              "width": 74.81793461573352,
              "height": 4.308704526934945
            }
          },
          {
            "page": -1,
            "type": "url",
            "url": "https://catalogointerattivo.net",
            "target": "_blank",
            "blueprint": {
              "top": 4.8905282398442,
              "left": 58.717499331023056,
              "width": 30.0,
              "height": 5.846687155078934
            }
          }
        ]
      },
      "categories": [],
      "pages": [
        {
          "number": 1,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/copertina_VZwC2t5.jpg",
          "products": []
        },
        {
          "number": 2,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_2_H1Bp6Wi.jpg",
          "products": []
        },
        {
          "number": 3,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_3_iGPpp32.jpg",
          "products": []
        },
        {
          "number": 4,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_4_fC865Pf.jpg",
          "products": []
        },
        {
          "number": 5,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_5_ORGikqK.jpg",
          "products": []
        },
        {
          "number": 6,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_6_1Q5mbYr.jpg",
          "products": []
        },
        {
          "number": 7,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_7_5xM3Mq9.jpg",
          "products": []
        },
        {
          "number": 8,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_8_jpu6pej.jpg",
          "products": []
        },
        {
          "number": 9,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_9_qXfJDPb.jpg",
          "products": []
        },
        {
          "number": 10,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_10_3oS6Snx.jpg",
          "products": [
            {
              "item_id": "cstm84930965",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 60.44231078818479,
                "left": 4.780443591384081,
                "width": 95.21955640861592,
                "height": 37.01684995274111
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_UGyZ5zD_ozRABpN.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/34_c.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 11,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_11_htaYUZz.jpg",
          "products": []
        },
        {
          "number": 12,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_12_6du25UW.jpg",
          "products": []
        },
        {
          "number": 13,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_13_2DkxOXg.jpg",
          "products": [
            {
              "item_id": "cstm62787421",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 11.06845809341011,
                "left": 0.0,
                "width": 39.91173491149499,
                "height": 27.831094049904028
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_6tcjk7z_NIVLWov.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/35_c.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 14,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_14_SXxH4D9.jpg",
          "products": []
        },
        {
          "number": 15,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_15_OiKyYyk.jpg",
          "products": []
        },
        {
          "number": 16,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_16_fJWkITQ.jpg",
          "products": []
        },
        {
          "number": 17,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/iperbimbo_pagina_17_LkOceBX.jpg",
          "products": [
            {
              "item_id": "cstm99987659",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 14.90017838819984,
                "left": 0.37252616750297995,
                "width": 95.3249093623374,
                "height": 25.29607031249815
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_5OIxAWM_9XghLJM.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/Tiny_Love_palestrina_Plush_Gymini_ITA.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 18,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_18_VzQebsb.jpg",
          "products": []
        },
        {
          "number": 19,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_19_rSfL2gc.jpg",
          "products": []
        },
        {
          "number": 20,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_20_jQThHZ6.jpg",
          "products": []
        },
        {
          "number": 21,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_21_EDqFHwr.jpg",
          "products": []
        },
        {
          "number": 22,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_22_oLj8ntz.jpg",
          "products": [
            {
              "item_id": "cstm67906930",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 11.708253358925145,
                "left": 37.54825122627426,
                "width": 57.55488910215397,
                "height": 41.33077415227127
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_LKvIZxD_iwFDisM.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/Peppa_Pig.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 23,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_23_Ui8pDSo.jpg",
          "products": [
            {
              "item_id": "cstm54931351",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 40.99253471652772,
                "left": 37.54825122627426,
                "width": 49.54318618042227,
                "height": 31.64256972241481
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_OM9FHv9_5rp1ZTN.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/Bing_Personaggi_e_Peluche.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 24,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_24_KFpqJrw.jpg",
          "products": []
        },
        {
          "number": 25,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_25_0DtaL4u.jpg",
          "products": []
        },
        {
          "number": 26,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_26_3aoez39.jpg",
          "products": [
            {
              "item_id": "cstm39559223",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 76.3915547024952,
                "left": 51.67383770526765,
                "width": 41.25783749200256,
                "height": 18.618042226487525
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_8Dvs7xp_IKOFk9Y.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/13.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 27,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_27_BXP7X7A.jpg",
          "products": []
        },
        {
          "number": 28,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_28_LCRyj6O.jpg",
          "products": [
            {
              "item_id": "cstm96464095",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 11.004478566858605,
                "left": 4.806381957773514,
                "width": 95.19361804222649,
                "height": 43.12220089571337
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_2kTtCas_C1ualpB.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/16.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 29,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_29_ExNK7p1.jpg",
          "products": [
            {
              "item_id": "cstm47618718",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 36.46833013435701,
                "left": 4.806381957773514,
                "width": 42.89749946683728,
                "height": 18.87396033269354
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_6wgRO66_bmGPLLz.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/30.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 30,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_30_VaIcyAU.jpg",
          "products": []
        },
        {
          "number": 31,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_31_Q7wgl5L.jpg",
          "products": []
        },
        {
          "number": 32,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_32_GnoSbFX.jpg",
          "products": []
        },
        {
          "number": 33,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_33_eiCEx9v.jpg",
          "products": [
            {
              "item_id": "cstm30466683",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 69.35380678182982,
                "left": 4.704841117509064,
                "width": 50.40714971209213,
                "height": 24.56813819577735
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_YAqtefV_i5HgAbQ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/37.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 34,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_34_sL94f1f.jpg",
          "products": [
            {
              "item_id": "cstm68908103",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 11.77223288547665,
                "left": 7.158802516528044,
                "width": 52.20564086159096,
                "height": 23.6724248240563
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_GH6Sq9Q_0BhLAU9.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/17.mov"
                }
              ]
            }
          ]
        },
        {
          "number": 35,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_35_sOMZdik.jpg",
          "products": [
            {
              "item_id": "cstm26474621",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 60.65259117082533,
                "left": 33.66877265941566,
                "width": 27.14331413947537,
                "height": 37.17210492642354
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_cNtfXPO_MJJHGfs.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/1_IT_Inventafiabe.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 36,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_36_RZmAtPI.jpg",
          "products": []
        },
        {
          "number": 37,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_37_NyS64xM.jpg",
          "products": [
            {
              "item_id": "cstm55055876",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 10.8765195137556,
                "left": 0.0,
                "width": 95.3635103433568,
                "height": 87.90786948176583
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_TYAApM1_DCMQkkv.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/2.mov"
                }
              ]
            }
          ]
        },
        {
          "number": 38,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_38_uR7cmWR.jpg",
          "products": []
        },
        {
          "number": 39,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_39_GcLYWDk.jpg",
          "products": []
        },
        {
          "number": 40,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_40_WvV8YwD.jpg",
          "products": [
            {
              "item_id": "cstm35911718",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 61.48432501599488,
                "left": 4.976274258903818,
                "width": 40.624493495414804,
                "height": 21.113243761996163
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_NvikMfH_U4n9QXO.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/38.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 41,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_41_cjAEMEI.jpg",
          "products": []
        },
        {
          "number": 42,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_42_08Be0Zb.jpg",
          "products": []
        },
        {
          "number": 43,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_43_1OYvM3p.jpg",
          "products": [
            {
              "item_id": "cstm88198162",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 11.644273832373642,
                "left": 4.976274258903818,
                "width": 87.67290467050543,
                "height": 85.28470889315419
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_HMjlK39_486FIS7.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/1_Crayola_Washimals__Novit%C3%A0_Natale_2020.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 44,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_44_8jpMO2R.jpg",
          "products": [
            {
              "item_id": "cstm39591605",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 46.963140010684064,
                "left": 7.377492211838004,
                "width": 87.75615264797511,
                "height": 26.914841473958997
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_fouWj2D_hmOL1Np.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/1_wnKu0O1.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 45,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_45_GaEI8ho.jpg",
          "products": []
        },
        {
          "number": 46,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_46_Bpr1Dqj.jpg",
          "products": []
        },
        {
          "number": 47,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_47_tP7rOLW.jpg",
          "products": [
            {
              "item_id": "cstm97686464",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 52.847088931541904,
                "left": 4.976274258903818,
                "width": 53.92471742375772,
                "height": 31.86180422264875
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_iqewL1F_1A1DS6F.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/25.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 48,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_48_L8nT8Sx.jpg",
          "products": []
        },
        {
          "number": 49,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_49_nQq2QcE.jpg",
          "products": []
        },
        {
          "number": 50,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_50_xBqIr0g.jpg",
          "products": []
        },
        {
          "number": 51,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_51_VKf0zgb.jpg",
          "products": [
            {
              "item_id": "cstm27938139",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 11.77223288547665,
                "left": 4.885796545105566,
                "width": 41.5292706333973,
                "height": 33.78119001919386
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_jpmnvFk_hc8Ypdb.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/24.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 52,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_52_BOG2lTh.jpg",
          "products": [
            {
              "item_id": "cstm66200529",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 11.77223288547665,
                "left": 4.885796545105566,
                "width": 56.09618255491575,
                "height": 35.892514395393476
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_Cb3fx2r_rhZvhzh.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/5.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 53,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_53_cWgFEV5.jpg",
          "products": []
        },
        {
          "number": 54,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_54_I2zUc0N.jpg",
          "products": [
            {
              "item_id": "cstm28642885",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 11.77223288547665,
                "left": 51.5722968650032,
                "width": 43.51978033695883,
                "height": 30.00639795265515
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_JRCNqDh_8vDYqXI.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/31.mov"
                }
              ]
            }
          ]
        },
        {
          "number": 55,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_55_Q7yqF3A.jpg",
          "products": [
            {
              "item_id": "cstm24196636",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 40.17914267434421,
                "left": 4.704841117509064,
                "width": 36.46251866069524,
                "height": 17.402431222008957
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_fTvEOBb_VIJxNpa.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/4.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 56,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_56_DcfxQdz.jpg",
          "products": []
        },
        {
          "number": 57,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_57_j5ZY9Xg.jpg",
          "products": [
            {
              "item_id": "cstm11642193",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 11.004478566858605,
                "left": 5.15722968650032,
                "width": 45.0579014715291,
                "height": 29.81445937300064
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_OyINaag_uBPMMq3.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/8.mp4"
                }
              ]
            },
            {
              "item_id": "cstm74880450",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 68.07421625079974,
                "left": 47.229366602687136,
                "width": 47.95318831307313,
                "height": 30.646193218170186
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_JLxotEb_QZwTrOm.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/9.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 58,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_58_olGsdeL.jpg",
          "products": [
            {
              "item_id": "cstm60311618",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 28.918746001279587,
                "left": 56.82000426530177,
                "width": 38.45302836425675,
                "height": 25.399872040946892
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_qlOUKjS_2RQnbKx.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/10.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 59,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/page_59_HH790P8.jpg",
          "products": [
            {
              "item_id": "cstm23679856",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 44.01791426743442,
                "left": 43.24834719556409,
                "width": 52.115163147792686,
                "height": 25.399872040946892
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_TiYnQeM_OWT70Lg.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/18.mp4"
                }
              ]
            },
            {
              "item_id": "cstm52090892",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 67.94625719769674,
                "left": 0.0,
                "width": 49.672264875239904,
                "height": 28.08701215611005
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_L25w1w7_OMYn2F9.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/19.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 60,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/2020IperBimbo_catalogo_giochii1_SlFmptT.jpg",
          "products": []
        },
        {
          "number": 61,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_61-min_1_dTENs5N.jpeg",
          "products": [
            {
              "item_id": "cstm35488393",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 25.07704264683289,
                "left": 4.872442455242973,
                "width": 40.58535805626598,
                "height": 25.74105537129585
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_IDVb8Ai_ge7SQjb.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/46.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 62,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_62_1K05aIV.jpeg",
          "products": []
        },
        {
          "number": 63,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_63_g63Czlm.jpeg",
          "products": [
            {
              "item_id": "cstm93924543",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 64.84686361869989,
                "left": 41.60453964194374,
                "width": 51.17071611253196,
                "height": 28.234661509403267
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_is5rCIr_jqyLUmQ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/42.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 64,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_64_z27onpZ.jpeg",
          "products": []
        },
        {
          "number": 65,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_65_h6FItHY.jpeg",
          "products": [
            {
              "item_id": "cstm12366743",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 70.48656611208011,
                "left": 4.781969309462922,
                "width": 55.513427109974415,
                "height": 26.380441560554164
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_3RxzmkM_DQ2Y6m0.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/43.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 66,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_66_x76PUnN.jpeg",
          "products": [
            {
              "item_id": "cstm81749271",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 70.58823529411765,
                "left": 7.341911764705888,
                "width": 88.03037084398976,
                "height": 26.40664961636828
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_PyFqCac_9fhXvwg.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/47.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 67,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_67_pVezFVL.jpeg",
          "products": [
            {
              "item_id": "cstm82843402",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 43.4405303064535,
                "left": 48.57097186700767,
                "width": 44.294757033248075,
                "height": 25.996809846999177
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_zlNkUfh_nEwXMz4.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/44.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 68,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_68_8wifGuz.jpeg",
          "products": [
            {
              "item_id": "cstm78375126",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 24.322883247629978,
                "left": 7.2247442455243025,
                "width": 51.62308184143221,
                "height": 22.48018580607846
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_DUv7CNR_oOpD2bB.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/45.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 69,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_69_ZnkFjsm.jpeg",
          "products": []
        },
        {
          "number": 70,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_70_YxmQKyP.jpeg",
          "products": [
            {
              "item_id": "cstm93069980",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 42.51918158567775,
                "left": 45.25015984654732,
                "width": 54.7498401534527,
                "height": 25.959079283887466
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_aKikNWP_g98AkEs.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/7.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 71,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_71_dsMgegC.jpeg",
          "products": []
        },
        {
          "number": 72,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_72_dXSmy1j.jpeg",
          "products": []
        },
        {
          "number": 73,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_73_82Hgv5S.jpeg",
          "products": [
            {
              "item_id": "cstm83866981",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 64.13043478260869,
                "left": 61.71627237851662,
                "width": 31.39418158567775,
                "height": 32.9923273657289
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_dlKluhJ_NRI9OU7.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/28.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 74,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_74_g5O6jhr.jpeg",
          "products": [
            {
              "item_id": "cstm61049824",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 30.754475703324804,
                "left": 33.03628516624041,
                "width": 30.94181585677749,
                "height": 31.010230179028127
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_FsMuC3B_8DIqxAe.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/26.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 75,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_75_YOvLfni.jpeg",
          "products": [
            {
              "item_id": "cstm71847463",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 66.04859335038363,
                "left": 4.808663682864456,
                "width": 44.51278772378516,
                "height": 30.69053708439897
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_jADjlLy_H1BOBr8.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/32.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 76,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_76_NDC5rAQ.jpeg",
          "products": []
        },
        {
          "number": 77,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_77_FBupK33.jpeg",
          "products": [
            {
              "item_id": "cstm43328143",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 53.13299232736572,
                "left": 4.7181905370844035,
                "width": 44.422314578005114,
                "height": 20.652173913043473
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_p2lCA1w_cNS0bVG.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/1_pokemon.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 78,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_78_othPTkp.jpeg",
          "products": []
        },
        {
          "number": 79,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_79_zKhtAvB.jpeg",
          "products": [
            {
              "item_id": "cstm90352715",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 11.508951406649617,
                "left": 4.7181905370844035,
                "width": 87.7589514066496,
                "height": 83.95140664961636
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_mw3EVz7_BFQyTiv.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/11.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 80,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_80_K4wm4Sy.jpeg",
          "products": [
            {
              "item_id": "cstm34660978",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 11.508951406649617,
                "left": 4.7181905370844035,
                "width": 87.7589514066496,
                "height": 83.95140664961636
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_Qs56Gyt_ygjg2Dw.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/3.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 81,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_81_G60fwfd.jpeg",
          "products": []
        },
        {
          "number": 82,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_82_KVLDJCz.jpeg",
          "products": []
        },
        {
          "number": 83,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_83_avukspU.jpeg",
          "products": [
            {
              "item_id": "cstm05839171",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 11.508951406649617,
                "left": 4.7181905370844035,
                "width": 87.7589514066496,
                "height": 85.35805626598464
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_4uKikLv_zr4GaPZ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/6.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 84,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_84_jor9ABS.jpeg",
          "products": []
        },
        {
          "number": 85,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_85_udBP5Iz.jpeg",
          "products": [
            {
              "item_id": "cstm18086649",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 42.007672634271096,
                "left": 26.250799232736572,
                "width": 29.22282608695651,
                "height": 26.15089514066496
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_vDB61tY_qD6Ih0i.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/1_cry.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 86,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_86_SD1S3cH.jpeg",
          "products": [
            {
              "item_id": "cstm14192973",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 10.869565217391303,
                "left": 4.899136828644506,
                "width": 35.46547314578004,
                "height": 39.83375959079284
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_p8zQJPx_oVxOJqu.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/20.mp4"
                }
              ]
            },
            {
              "item_id": "cstm39835756",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 75.38363171355498,
                "left": 39.82177109974425,
                "width": 30.670396419437335,
                "height": 22.50639386189258
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_5qWABTk_JHkyaEg.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/1_Cicciobello_Monello.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 87,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_87_2RmJfkh.jpeg",
          "products": [
            {
              "item_id": "cstm84500814",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 59.20716112531969,
                "left": 4.989609974424558,
                "width": 87.66847826086956,
                "height": 25.511508951406643
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_tewj51S_QCNxvPZ.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/41.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 88,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_88_AlNZ7E0.jpeg",
          "products": [
            {
              "item_id": "cstm52202585",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 11.76470588235294,
                "left": 6.980019181585682,
                "width": 88.30179028132991,
                "height": 85.0383631713555
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_ZLMXneR_chPKYIw.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/40.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 89,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_89_YaDbfeE.jpeg",
          "products": []
        },
        {
          "number": 90,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_90_MZXWKmT.jpeg",
          "products": []
        },
        {
          "number": 91,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_91_J4tBpCG.jpeg",
          "products": [
            {
              "item_id": "cstm61976253",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 68.60613810741687,
                "left": 39.097985933503836,
                "width": 53.288682864450124,
                "height": 28.9002557544757
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_U1bWuMI_Lyfyqu9.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/21.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 92,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_92_ENBlVcP.jpeg",
          "products": [
            {
              "item_id": "cstm93757109",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 32.864450127877234,
                "left": 42.35501918158568,
                "width": 51.1173273657289,
                "height": 18.35038363171355
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_pN1YFuy_P0aI4gx.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/14.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 93,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_93_yqQb5U0.jpeg",
          "products": [
            {
              "item_id": "cstm41535613",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 12.084398976982095,
                "left": 41.721707161125316,
                "width": 51.1173273657289,
                "height": 37.65984654731457
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_7fuLnAS_o95njh0.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/1_Na_Na_Na_Surprise_Nuova_collezione.mp4"
                }
              ]
            },
            {
              "item_id": "cstm88717810",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 50.51150895140665,
                "left": 56.74024936061382,
                "width": 34.92263427109974,
                "height": 42.327365728900254
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_qmmJ4MM_kJV5BfG.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/1_LOL.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 94,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_94_UoafV1m.jpeg",
          "products": [
            {
              "item_id": "cstm36189085",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 16.68797953964194,
                "left": 4.899136828644506,
                "width": 39.98913043478261,
                "height": 34.14322250639387
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_EZvGJhd_u5YvkgR.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/1_rmx.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 95,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_95_LbGwPf5.jpeg",
          "products": [
            {
              "item_id": "cstm28754958",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 41.87979539641943,
                "left": 41.450287723785166,
                "width": 53.37915601023017,
                "height": 27.173913043478258
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_FKs3OKV_RPdIPaP.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/27.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 96,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_96_wOwxIOQ.jpeg",
          "products": [
            {
              "item_id": "cstm82755056",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 70.39641943734016,
                "left": 4.899136828644506,
                "width": 53.10773657289002,
                "height": 26.470588235294112
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_wcA0g9F_LEzIdUA.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/1_nancy.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 97,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_97_cLUFRFD.jpeg",
          "products": [
            {
              "item_id": "cstm06787785",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 24.04092071611253,
                "left": 49.05003196930946,
                "width": 46.23177749360613,
                "height": 30.370843989769817
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_jg2rFP4_P4a9iXL.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/33.mp4"
                }
              ]
            },
            {
              "item_id": "cstm26290911",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 71.99488491048592,
                "left": 0.013586956521744688,
                "width": 95.19133631713555,
                "height": 26.662404092071608
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_8HBYlSk_nPFRRHP.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/36.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 98,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_98_a9pfpEM.jpeg",
          "products": []
        },
        {
          "number": 99,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_99_vhbbRCr.jpeg",
          "products": [
            {
              "item_id": "cstm15764541",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 12.531969309462914,
                "left": 53.12132352941177,
                "width": 42.070012787723776,
                "height": 24.552429667519178
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_prk0SeP_eUFnoui.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/29.mp4"
                }
              ]
            },
            {
              "item_id": "cstm23471452",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 12.531969309462914,
                "left": 0.0,
                "width": 44.345428388746804,
                "height": 25.44757033248081
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_7IBY9Iw_JybUzqb.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/23.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 100,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_100_LH076MC.jpeg",
          "products": [
            {
              "item_id": "cstm83504432",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 68.79795396419436,
                "left": 9.047314578005114,
                "width": 83.15840792838873,
                "height": 26.470588235294112
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_d5MOnSb_8OiBMG9.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/15.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 101,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_101_tpdO6q7.jpeg",
          "products": []
        },
        {
          "number": 102,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_102_nRLrx8S.jpeg",
          "products": []
        },
        {
          "number": 103,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_103_5iKXYxY.jpeg",
          "products": [
            {
              "item_id": "cstm41849764",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 32.544757033248075,
                "left": 6.708599744245529,
                "width": 84.50191815856776,
                "height": 32.09718670076726
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_tz2vIXY_TJTmeW4.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/12.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 104,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_104_wKJ3aN5.jpeg",
          "products": []
        },
        {
          "number": 105,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_105_rxzNqmY.jpeg",
          "products": [
            {
              "item_id": "cstm62306565",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 40.473145780051155,
                "left": 4.899136828644506,
                "width": 50.48401534526854,
                "height": 30.9462915601023
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_J6nUTLe_hktHS0w.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/22.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 106,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_106_JMTyPk6.jpeg",
          "products": []
        },
        {
          "number": 107,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_107_PPpDqQG.jpg",
          "products": []
        },
        {
          "number": 108,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_108_ClAzkqo.jpeg",
          "products": []
        },
        {
          "number": 109,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_109_ely7uXY.jpeg",
          "products": []
        },
        {
          "number": 110,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_110_vYVFnzY.jpeg",
          "products": [
            {
              "item_id": "cstm37423817",
              "field1": "",
              "field2": "",
              "field3": "",
              "field4": "",
              "description": "",
              "grammage": null,
              "price": "0.00",
              "price_label": "",
              "equivalence": null,
              "quantity_step": null,
              "grocery_label": "",
              "varieties": [],
              "price_for_kg": null,
              "available_pieces": null,
              "max_purchasable_pieces": null,
              "points": "",
              "fidelity_product": false,
              "focus": false,
              "pam": true,
              "three_for_two": false,
              "one_and_one_gratis": false,
              "underpriced_product": false,
              "category": null,
              "subcategory": null,
              "blueprint": {
                "top": 10.933503836317135,
                "left": 4.899136828644506,
                "width": 95.1008631713555,
                "height": 54.92327365728899
              },
              "images": [
                {
                  "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/products/cropped_image_yi1hxQ7_w0mRyl6.png",
                  "cropped": true
                }
              ],
              "markers": [
                {
                  "type": "plus",
                  "title": null,
                  "data": ""
                },
                {
                  "type": "play",
                  "title": "",
                  "data": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/video/39.mp4"
                }
              ]
            }
          ]
        },
        {
          "number": 111,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/pag_111_Tgh0x2d.jpg",
          "products": []
        },
        {
          "number": 112,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_112_vYL2Zcr.jpeg",
          "products": []
        },
        {
          "number": 113,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/IperBimbo_catalogo_giochi_2020_113_E0lMdBg.jpeg",
          "products": []
        },
        {
          "number": 114,
          "image_file": "https://interattivo.s3.amazonaws.com/g4nrsoFuJ0/pages/fine-Iperbimbo_AIjEmc9.png",
          "products": []
        }
      ]
    }
  }

}

const lefletSwitch = () => {
  return leaflets.iperbimbo;
}

export const serverResponse = lefletSwitch(); 